import { React, useState, useEffect } from "react";
import "./rms-base.scss";

function RmsBase(props) {
  const { buildingData, node } = props;
  const [buildingDataState, setBuildingDataState] = useState({});
  // const token = sessionStorage.getItem("accessToken");
  const tenantId = sessionStorage.getItem("tenantId");
  const [nodeState, setNodeState] = useState({});

  const getLatLong = (latLongString) => {
    const longLatArray = [];
    let latLongSplit = [];
    if (latLongString) {
      latLongSplit = latLongString.split(",");
      longLatArray.push(parseFloat(latLongSplit[1]));
      longLatArray.push(parseFloat(latLongSplit[0]));
    }
    return longLatArray;
  };

  const prepareRMS = () => {
    if (buildingData && buildingData.id && node && node.richMapInfo && node.richMapInfo.lhLevel !== undefined && node.richMapInfo.lhLevel !== null) {
      const longLat = getLatLong(buildingData.geoLocation);
      const parentBuildingId = buildingData.id;
      const floorLevel = node.richMapInfo.lhLevel;
      const floor = node;
      if (longLat) {
        try {
          const rMap = new RichMap({
            useTiles: false,
            mapContainer: "rms-map",
            tenantId,
            locationId: parentBuildingId,
            initialZoom: 21,
            initialPos: longLat,
            initialPitch: 65,
            initialBearing: 90,
            defaultFloor: floorLevel
          });

          // for rich map orientation (parity)
          if (floor.richMapInfo && floor.richMapInfo.bounds) {
            const bounds = [];
            floor.richMapInfo.bounds.forEach((bound) => {
              const boundArr = [bound.longitude, bound.latitude];
              bounds.push(boundArr);
            });
            if (rMap && rMap.map) {
              rMap.map.fitBounds(bounds, { padding: 10, maxZoom: 20 });
            }
          }
        } catch (e) {
          console.error(e);
        }
      }
    } else {
      // props unavailable for richmap
      console.log("Building and Floor data missing in app props");
    }
  };

  useEffect(() => {
    console.log(`${buildingDataState} ${nodeState}`);
    if (buildingData) {
      setBuildingDataState(buildingData);
    }
    if (node) {
      setNodeState(node);
    }
    // prepareRMS();
  }, []);

  useEffect(() => {
    if (buildingData && buildingData.id && node && node.id) prepareRMS();
  }, [buildingData, node]);

  return (
    <div id="rms-map" className="rms-map">
      Rich Map Loading...
    </div>
  );
}

export default RmsBase;
